import React, { useState } from 'react';
import Btn from '../../../components/ui/Btn';
import StatusTag from '../../../components/ui/StatusTag';
import ConfirmModal from '../../../components/ui/ConfirmModal';

const when = (iso) => (iso ? new Date(iso).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' }) : '');

// Historial: cada publicación es una versión fija. Se puede ver y copiar al borrador para volver a una anterior.
export default function VersionsPanel({ versions, publishedVersion, draftDirty, onCopyToDraft }) {
  const [open, setOpen] = useState(null);
  const [copying, setCopying] = useState(null);
  const published = versions.filter((v) => v.state === 'published');
  if (!published.length) return <p className="text-sm text-fg-dim">Todavía no hay versiones publicadas. Cuando publiques, cada versión quedará aquí y podrás volver a ella.</p>;
  return (
    <ol className="max-w-3xl rounded-xl border border-line divide-y divide-line">
      {published.map((v) => (
        <li key={v.id} className="p-4">
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-sm font-medium text-fg tabular-nums">Versión {v.version}</span>
            {v.version === publishedVersion && <StatusTag tone="live" dot>En uso</StatusTag>}
            <span className="text-[12.5px] text-fg-faint">{when(v.published_at || v.created_at)}</span>
            <div className="ml-auto flex gap-2">
              <Btn size="sm" variant="ghost" aria-expanded={open === v.id} onClick={() => setOpen(open === v.id ? null : v.id)}>{open === v.id ? 'Ocultar' : 'Ver instrucciones'}</Btn>
              <Btn size="sm" onClick={() => setCopying(v)}>Copiar al borrador</Btn>
            </div>
          </div>
          {open === v.id && <pre className="mt-3 max-h-80 overflow-auto whitespace-pre-wrap rounded-lg bg-ink border border-line p-4 text-[13px] leading-relaxed text-fg-dim font-sans">{v.prompt || '(vacías)'}</pre>}
        </li>
      ))}
      <ConfirmModal open={Boolean(copying)} onClose={() => setCopying(null)} title={`Copiar la versión ${copying?.version} al borrador`} confirmLabel="Copiar al borrador" onConfirm={() => onCopyToDraft(copying)}>
        <p>El borrador tomará las instrucciones y el comportamiento de esa versión. Lo que respondan los canales no cambia hasta que publiques.</p>
        {draftDirty && <p className="text-caution">El borrador tiene cambios sin publicar: se reemplazarán.</p>}
      </ConfirmModal>
    </ol>
  );
}
